const localstorageKeySet = {
  ECOYA_ADMIN_ID: 'ecoya_admin_id',
};

export { localstorageKeySet };
